// extracted by mini-css-extract-plugin
module.exports = {"PanelButtons":"styles_PanelButtons__E7tPQ","button":"styles_button__asHwV"};